import { Box } from '@mybridge/ui';
import { useChatSocket } from 'packages/mybridgev4/hooks/useChatSocket';
import { forwardRef, useEffect, useState } from 'react';
export const MATRIX_PRESENCE = {
  online: {
    bgColor: 'green.500',
    priority: 2,
  },
  busy: {
    bgColor: 'red.500',
    priority: 1,
  },
  offline: {
    bgColor: 'gray.500',
    priority: 0,
  },
};
export const UserPresenceDot = forwardRef(
  ({ children, user, wrapperProps, type, ...props }, ref) => {
    const {onEvent} = useChatSocket();
    const [presenceFromSocket, setPresenceFromSocket] = useState()

    useEffect(() => {
      const unsubPresenceEvent = onEvent('presence.update', (data) => {
        if(Number(data?.user_id) === Number(user?.id)){
          setPresenceFromSocket(data?.presence);
        }
      });
  
      return () => {
        unsubPresenceEvent();
      }
    }, [onEvent]);

    return (
      <>
        <Box pos="relative" {...(wrapperProps ?? {})}>
          {children}
          <Box
            pos="absolute"
            bottom="0"
            right="0"
            borderRadius="full"
            w="3"
            h="3"
            border="2px solid white"
            {...(MATRIX_PRESENCE[type === "chat" ? user?.presence : presenceFromSocket ?? user?.presence] ?? MATRIX_PRESENCE?.offline)}
            {...(props ?? {})}
          />
        </Box>
      </>
    );
  }
);
